module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "05dashboard.92281060.png" + "?" + Date.now();